module.exports = __webpack_public_path__ + "img/gauntlets_3.8adb1ffe.png";